<template>
  <div>
    <serveur-info :erreur="erreur" />
    <div class="container is-fluid">
      <div class="columns">
        <div class="column">
          <b-notification :closable="false">
            <div class="level-item has-text-centered">
              <div>
                <b-tooltip
                  type="is-dark"
                  :label="
                    $t('compTransitionMapsTableItems.tooltip-nActionsTotal')
                  "
                  multilined
                  append-to-body
                >
                  <p class="heading">
                    {{ $t('compTransitionMapsTableItems.nActionsTotal') }}
                    <b-icon size="is-small" icon="info-circle"></b-icon>
                  </p>
                </b-tooltip>
                <div class="title is-size-2">
                  <p>{{ count }}</p>
                </div>
              </div>
            </div>
          </b-notification>
        </div>

        <div class="column">
          <b-notification :closable="false">
            <div class="level-item has-text-centered">
              <div>
                <b-tooltip
                  :active="displayedItems.length < count"
                  type="is-dark"
                  :label="
                    $t('compTransitionMapsTableItems.tooltip-nActionsDisplayed')
                  "
                  multilined
                  append-to-body
                >
                  <p class="heading">
                    {{ $t('compTransitionMapsTableItems.nActionsDisplayed') }}
                    <b-icon
                      v-if="displayedItems.length < count"
                      size="is-small"
                      icon="info-circle"
                    ></b-icon>
                  </p>
                </b-tooltip>
                <div class="title is-size-2">
                  <p>{{ displayedItems.length }}</p>
                </div>
              </div>
            </div>
          </b-notification>
        </div>

        <div class="column">
          <b-notification :closable="false">
            <div class="level-item has-text-centered">
              <div>
                <b-tooltip
                  :active="displayedItems.length < count"
                  type="is-dark"
                  :label="
                    $t('compTransitionMapsTableItems.tooltip-nLaboratories')
                  "
                  multilined
                  append-to-body
                >
                  <p class="heading">
                    {{ $t('compTransitionMapsTableItems.nLaboratories') }}
                    <b-icon
                      v-if="displayedItems.length < count"
                      size="is-small"
                      icon="info-circle"
                    ></b-icon>
                  </p>
                </b-tooltip>
                <div class="title is-size-2">
                  <p>{{ nLaboratories }}</p>
                </div>
              </div>
            </div>
          </b-notification>
        </div>
      </div>
      <hr />

      <section class="sidebar-layout">
        <div class="tile is-ancestor">
          <div
            :class="`tile is-parent is-vertical ${columnSize}`"
            v-for="idx in nbColumn"
            :key="`column-${idx}`"
          >
            <div
              class="tile is-child"
              v-for="(action, index) in partition[idx - 1]"
              :key="`card-${index}`"
            >
              <card-action
                :item="action"
                @open="(item) => $emit('onOpenItem', item)"
                @on-click-file="(file) => $emit('onClickFile', file)"
              >
              </card-action>
            </div>
          </div>
        </div>
        <b-button
          :disabled="displayedItems.length >= count"
          rounded
          size="is-small"
          @click="loadMore"
          >{{ $t('compTransitionMapsTableItems.load-more') }} ({{
            displayedItems.length
          }}
          / {{ count }})
        </b-button>
      </section>
    </div>
  </div>
</template>

<script>
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import _ from 'lodash'

export default {
  name: 'TableItems',
  components: {
    'serveur-info': () => import('@/components/ServeurInfo.vue'),
    'card-action': () => import('@/components/transition/maps/CardAction.vue')
  },
  emits: ['onOpenItem', 'onClickFile'],
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    count: {
      type: Number,
      required: true
    },
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    },
    localPageSize: {
      type: Number,
      required: false,
      default: () => 50
    }
  },
  data: function () {
    return {
      erreur: '',
      loading: true,
      localPage: 1
    }
  },
  watch: {
    items: function (newItems, oldItems) {
      if (newItems.length <= oldItems.length) {
        // rationale: reinitialize localPage when a new filter is applied
        // ie which happens when the number of items change in a decreasing way
        this.localPage = 1
      }
    }
  },
  computed: {
    nbColumn () {
      if (this.fullscreen) {
        return 5
      }
      return 2
    },
    displayedItems () {
      return this.items.slice(0, this.localPage * this.localPageSize)
    },
    /**
     * Partition the items in several columns
     */
    partition () {
      let total = this.displayedItems.length

      let partition = []

      for (let i = 0; i < this.nbColumn; i++) {
        let idx = i * Math.floor(total / this.nbColumn)
        let nextIdx = (i + 1) * Math.floor(total / this.nbColumn)
        partition.push([idx, nextIdx])
      }
      // account for the reminder
      let r = 0
      for (let k = 0; k < partition.length - 1; k++) {
        if (r < total % this.nbColumn) {
          r += 1
        }
        // adjust
        partition[k][1] = partition[k][1] + r
        partition[k + 1][0] = partition[k + 1][0] + r
      }
      partition[this.nbColumn - 1][1] = total
      let slices = []
      for (let p of partition) {
        slices.push(this.items.slice(p[0], p[1]))
      }
      return slices
    },
    nLaboratories () {
      return _.uniq(this.displayedItems.map((d) => d.entity.id)).length
    },
    columnSize: function () {
      let css = 12 / this.nbColumn
      return `is-${css}`
    }
  },
  methods: {
    loadMore () {
      if (this.displayedItems.length >= this.items.length) {
        // ask for more
        this.$emit('onLoadMore')
        this.localPage = this.localPage + 1
      } else {
        // just increase the number of displayedItems
        this.localPage = this.localPage + 1
      }
    }
  }
}
</script>
